import React, { Component } from "react";
import moment from "moment";
import { Alert, Badge, Button, UncontrolledTooltip } from "reactstrap";
import { MdErrorOutline } from "react-icons/md";
import db from "../../pages";
import { async } from "q";
import { fetchData } from "../common/networkRequests";
import { getRequiredField, getCookie } from '../oro-module/commonFunctions';
import { handleConfirmSubmit } from "../oro-module/ajaxdata";
import { IoMdCloseCircleOutline } from "react-icons/io";
import SelectAudit from "./SelectAudit";

const styles = {
  requiredFields: {
    backgroundColor: "white",
    color: "black",
    border: "1px solid gold",
    textAlign: "left"
  },
  formErrors: {
    backgroundColor: "white",
    color: "black",
    border: "1px solid gold",
    textAlign: "left",
    maxWidth: 500
  }
};

const ShowAuditTrail = ({ auditorsData }) => {
  return (
    <ol>
      <li>
        <b>Date: & User</b>
        <ol><li>Change 1</li>
          <li>Change 2</li>
        </ol>
      </li>
      <li>
        <b>Date 2: & User 2</b>
        <ol><li>Change 1</li>
          <li>Change 2</li>
          <li>Change 3</li>
        </ol>
      </li>
    </ol>
  )
}

// const  getCookie = (cname) => {
//   var name = cname + "=";
//   var decodedCookie = decodeURIComponent(document.cookie);
//   var ca = decodedCookie.split(';');
//   for(var i = 0; i <ca.length; i++) {
//     var c = ca[i];
//     while (c.charAt(0) == ' ') {
//       c = c.substring(1);
//     }
//     if (c.indexOf(name) == 0) {
//       return c.substring(name.length, c.length);
//     }
//   }
//   return "";
// }

function toCamelCase(str) {
  return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
    return index == 0 ? word.toUpperCase() : word.toUpperCase();
  }).replace(/\s+/g, ' ');
}

function varToLabel(varname) {
  return toCamelCase(varname.replace(/_/g, " "));
}

class Header extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);

    this.state = { VED: "default", dropdownOpen: false }; // view edit delete initialized
  }

  handleClick(val) {
    this.setState({ VED: "changed" });
    this.props.liftGlobalState({ name: "formState" }, val);
    this.props.liftGlobalState({ name: "otherPage" }, "");
  }

  handleRevert = async () => {
    // 

    let lgs = this.props.liftGlobalState;
    let {
      alerts,
      unsavedChanges,
      errorMessages,
      currentPage,
      pageData,
      LocalVars,
      formElements, notifications, remoteip
    } = this.props.parentState;
    currentPage = currentPage.toLowerCase();
    const formDefinition = formElements[currentPage]["form"];
    let shouldProceed = true;
    let errors = [];
    // !errorMessages && (errorMessages = {Login :"Login Error"}); 

    for (var i = 0; i < formDefinition.length; i++) {
      let shouldRender = 1;
      let component = formDefinition[i];
      if (component.parents) {
        for (var j = 0; j < component.parents.length; j++) {
          let elem = component.parents[j];

          const parentVal = this.props.parentState.pageData[elem.name];

          if (
            elem.reverse &&
            ((elem.match === "exist" && parentVal) ||
              (elem.match === "value" && parentVal == elem.value))
          ) {
            shouldRender = 0;
            errors.push("1");
          } else if (
            !elem.reverse &&
            ((elem.match === "exist" && parentVal) ||
              (elem.match === "value" && parentVal == elem.value))
          ) {
            shouldRender = 1;
          } else {
            if (!elem.reverse) {
              shouldRender = 0;
            }
          }
        }
      }
    }

    getRequiredField({ shouldProceed: false, current: this })

    if (shouldProceed) {
      // Clean all form values to be saved in saveThis by removing unnecessary values.
      currentPage = currentPage.toLowerCase();
      const formDefinition = formElements[currentPage]["form"];
      console.log(this.props.parentState);
      let { token } = this.props.parentProps.parentState;

      let saveThis = {};
      saveThis['pageData'] = JSON.parse(JSON.stringify(this.props.parentState)).pageData;
      saveThis['currentPage'] = currentPage;


      // print message if no connection. After check if it is saved locally then dont show the message again.
      // unsavedChanges.push(1);
      // alerts.unshift({
      //   value:
      //     String(unsavedChanges.length) +
      //     " Changes made but not saved yet. Dont close this window.",
      //   alertType: "warning"
      // });

      // lgs({ name: "alerts" }, alerts); NO NEED to lift the state !!!!
      // formSubmittedClass="animated zoomOut"; BUT cant do this, because its NOT object. So the following line is necessary.
      // LocalVars["formSubmittedClass"] = "animated zoomOut";
      lgs({ name: "LocalVars" }, LocalVars);


      // Clear form - restore default values for that form after submitting.
      let defaultFormData = {};
      ;
      this.setState({ isSubmit: true });

      let CBSurl = `${remoteip}/sentry`;
      let url = CBSurl;
      let method = 'post';

      // saveThis['vendorSpecific']={};

      saveThis['dataType'] = 'revert'
      // saveThis['pageData']['submit_type'] = "";

      // Loop to remove fields having _display in their name

      // save data to form.
      let { results, exceptions, error } = await fetchData({ url, postData: saveThis, method, headers: { Authorization: `JWT ${this.props.parentProps.parentState.token}` } });
      if (error) {
        notifications = { value: "Can not connect to the main server", alertType: "warning" };
        lgs({ name: 'notifications' }, notifications);
        // this.setState({ isSubmit: false });

      } else if (results && results[0]) {
        // console.log("hdhfdh")
        // alert(`Account Deposite ${results[0][0]} record created`);

        // alerts.unshift({value:`Account Deposite ${results[0][0]} record created`,alertType:"success"});
        // alerts.unshift({value:"Data save successfully",alertType: "success"})
        // lgs({ name: "alerts" }, alerts);
        // // lgs({ name: "unsavedChanges" }, []);
        // LocalVars["formSubmittedClass"] = "";
        // lgs({ name: "LocalVars" }, LocalVars);
        // let buttontype = { submit: false, search: false, edit: false }
        // setTimeout(function () {
        //   lgs({ name: "alerts" }, []);
        //   lgs({ name: "showButtons" }, buttontype);
        // }, 500);
        // lgs({ name: 'pageData' }, {});
      }
      else {
        if (Object.keys(exceptions).length != 0) {
          alerts.unshift({ value: exceptions.message, alertType: "danger" })
          this.setState({ isSubmit: false });
          if (exceptions.message.includes("The user has been logged off.") == true) {
            setTimeout(() => document.getElementById("logout-button-hidden").click(), 10);
          }
        } else {
          // alerts.unshift({value:"Data save successfully",alertType: "success"})
          // alert(`record created`);
          // LocalVars["formSubmittedClass"] = "";
          // // let buttontype = { submit: false, search: false, edit: false }
          // lgs({ name: "LocalVars" }, LocalVars);
          // // lgs({ name: 'pageData' }, {});
          // // lgs({ name: "alerts" }, []);
          // // lgs({ name: "showButtons" }, buttontype);
        }
        lgs({ name: "alerts" }, alerts);
        lgs({ name: "unsavedChanges" }, []);
        let buttontype = { submit: false, search: false, edit: false }

        // setTimeout(function () {
        //   lgs({ name: "alerts" }, []);
        //   lgs({ name: 'pageData' }, {});
        //   lgs({ name: "showButtons" }, buttontype);
        // }, 500);


      }

      // this.setState({ isSubmit: false });
      // this.setState({ submitConfirm: false })

    } else {

      // alerts.unshift({
      //   value: "There are errors on the form shown in RED color.",
      //   alertType: "danger"
      // });

      // lgs({ name: "alerts" }, alerts);
      // this.setState({ submitConfirm: false })
    }


  }

  handleApprove = async () => {
    // Set two fields in pagedata
    let { identi } = this.props.parentProps.parentState
    let def
    if (identi) {
      def = JSON.parse(getCookie(identi + "_report"));
      let notify_user, reverted

      if (def) {
        notify_user = def['notify_user']
        reverted = def['reverted']
      }
      let otherPageData = { submit_type: 'approve', notify_user, reverted }
      console.log(otherPageData)
      // let otherPageData={reverted:'',:'',submit_type:''};
      handleConfirmSubmit({ current: this, otherPageData })

    }


  }

  handleClose = (e) => {
    //code for closing filefolder.
    // console.log(e)
    if (this.props.parentState.fileFolder.isOpen) {
      // console.log("Hii")
      // const { fileFolder } = this.props.parentState;
      // fileFolder.isOpen = true;
      // fileFolder.recordID = "";
      // fileFolder.isClosing = true;

      // this.props.liftGlobalState({ name: "fileFolder" }, fileFolder);
      // this.props.liftGlobalState({ name: "pageData" }, {});

      setTimeout(() => {
        const { fileFolder } = this.props.parentState;
        fileFolder.isOpen = false;
        fileFolder.recordID = "";
        fileFolder.isClosing = false;
        this.props.liftGlobalState({ name: "formState" }, "");
        this.props.liftGlobalState({ name: "fileFolder" }, fileFolder);

        // this.props.liftGlobalState({ name: "currentPage" }, "pages");
        // this.props.liftGlobalState({ name: "currentPageLabel" }, "pages");
        // this.props.liftGlobalState({ name: "alerts" }, []);
        this.props.liftGlobalState({ name: "pageData" }, {});
        this.props.liftGlobalState({ name: "auditorsData" }, []);
        this.props.liftGlobalState({ name: "auditorsPass" }, "");
        this.props.liftGlobalState({ name: "formState" }, "edit");

        this.props.liftGlobalState({ name: "errorMessages" }, {});

        // this.props.liftWrapperState({ name: "currentPage" }, "pages");
      }, 500);
    }
  }

  componentDidMount() {
    if (this.state.VED == "default") {
      let { currentPage, formElements } = this.props.parentState;

      let { formState } = formElements[currentPage];
      let r;

      formState && formState.checked
        ? this.props.liftGlobalState({ name: "formState" }, formState.checked)
        : this.props.liftGlobalState({ name: "formState" }, "view");
    }
    // document.addEventListener("click", this.handleClose, false);
  }

  changeOtherPage = selected => {
    this.props.liftGlobalState({ name: "otherPage" }, selected);
    let { starting } = db[selected];
    if (starting) {
      this.props.liftGlobalState(
        { name: "pageData" },
        this.props.parentState.workFlowData.pageData
      );
    } else {
      this.props.liftGlobalState(
        { name: "pageData" },
        this.props.parentState.workFlowData[selected].pageData
      );
    }
  };

  clearNotification = () => {
    this.props.liftGlobalState({ name: 'notifications' }, {});
  }

  handleAuditorsLogin = async () => {
    let { auditorsPass, pageData, currentPage, remoteip } = this.props.parentState;
    let saveThis = { uid: pageData.uid, auditorsPass, currentPage, dataType: "audit" };
    let method = "post";
    let CBSurl = `${remoteip}/sentry`;
    let lgs = this.props.liftGlobalState;

    // On clicking load, send that UID and get the data.
    let response = await fetchData({ url: CBSurl, postData: saveThis, method, headers: { Authorization: `JWT ${this.props.parentProps.parentState.token}` } });
    let auditorsData = [];

    let { results, error } = response;
    if (response == 'jwt expired' || response == 'jwt malformed') {
      let notifications = { value: "Session expired", alertType: "warning" };
      lgs({ name: 'notifications' }, notifications);
      setTimeout(() => document.getElementById("logout-button-hidden").click(), 10);
    } else if (results && results.hits) {
      for (var i = 0; i < results.hits.length; i++) {
        let { pageData, username, timestamp } = results.hits[i]._source;
        auditorsData.unshift({ pageData, username, timestamp });
      }
      lgs({ name: 'auditorsData' }, auditorsData);
    } else if (error) {
      let notifications = { value: error, alertType: "warning" };
      lgs({ name: 'notifications' }, notifications);
    }

    // Similarly always send a dynamic one time uid whenever loading reports / populating / on 'clicking edit' etc.
  }




  render() {
    let {
      currentPage,
      fileFolder,
      pageData,
      formState,
      formElements, fileFolderError, globalFormActions,
      formProgress, notifications
    } = this.props.parentState;

    let { identi } = this.props.parentProps.parentState



    let {
      pageType,
      folderTitle,
      formActions,
      otherVisiblePages,
      starting,
      pageLabel,
      label
    } = formElements[currentPage];

    if (globalFormActions[currentPage]) {
      formActions = globalFormActions;
    }

    let { otherPage, auditorsData, auditorsSelection } = this.props.parentState;
    return (
      <div className="row">
        <div className="col-6">
          <div className="row">
            <div className="col-12" style={{ fontSize: 22 }}>
              {folderTitle ? folderTitle : pageLabel}
              {pageData.date
                ? " on " +
                moment(pageData.date, "YYYYMMDD").format("DD/MM/YYYY")
                : ""}
              {formProgress && formProgress.length > 0 &&
                <span>
                  &nbsp;
                  <MdErrorOutline
                    id="formProgress"
                    style={{
                      fontSize: "20px",
                      // border: "1px solid #ced4da",
                      // borderRadius: "0.25rem",
                      color: "#990000",
                      borderColor: "white",
                    }}
                    className="animated pulse infinite hand"
                  />
                  <UncontrolledTooltip style={styles.requiredFields} placement="bottom" target="formProgress">
                    <b>Required fields</b>
                    <ol>
                      {formProgress.map((v, i) =>
                        <li key={i}>{v.msg ? varToLabel(v.val) + " in " + v.msg : varToLabel(v.val)}</li>
                      )
                      }
                    </ol>
                  </UncontrolledTooltip>
                </span>
              }
            </div>

            {pageType == "history" && (
              <div className="col-12">
                <Badge
                  color="dark"
                  onClick={() => this.handleClick("view")}
                  className={`link-button ${formState == "view" ? "link-button-selected" : ""
                    }`}
                >
                  View
                </Badge>{" "}
                &nbsp;
                {formActions &&
                  formActions.edit &&
                  formActions.edit.allow && (
                    <span>
                      <Badge
                        color="warning"
                        onClick={() => this.handleClick("edit")}
                        className={`link-button ${formState == "edit" ? "link-button-selected" : ""
                          }`}
                      >
                        {formActions &&
                          formActions.edit &&
                          formActions.edit.text && (
                            <span>{formActions.edit.text}</span>
                          )}
                        {(!formActions ||
                          !formActions.edit ||
                          !formActions.edit.text) && <span>Edit</span>}
                      </Badge>{" "}
                      &nbsp;
                    </span>
                  )}
                {formActions &&
                  formActions.delete &&
                  formActions.delete.allow && (
                    <Badge
                      color="danger"
                      onClick={() => this.handleClick("delete")}
                      className={`link-button ${formState == "delete" ? "link-button-selected" : ""
                        }`}
                    >
                      Delete
                    </Badge>
                  )}{" "}
                &nbsp;

                {formActions &&
                  formActions.audit &&
                  formActions.audit.allow && (
                    <Badge
                      color="info"
                      onClick={() => this.handleClick("audit")}
                      className={`link-button ${formState == "audit" ? "link-button-selected" : ""
                        }`}
                    >
                      Audit
                    </Badge>
                  )}
              </div>
            )}
          </div>
        </div>
        <div className="col-6">
          <div className="row">
            <div className="col-11" >
              <div>{notifications && notifications.value ? <Alert color="warning"><IoMdCloseCircleOutline className="hand" onClick={this.clearNotification} /> {notifications.value}</Alert> : ' '}</div>
            </div>
            <div className="col-1" style={{ float: 'right' }}>
              <Badge
                onClick={this.handleClose}
                style={{ cursor: "pointer", float: 'right' }}
                color="danger"
              >
                Close
              </Badge>
            </div>
          </div>

          {formState == 'audit' && auditorsData.length == 0 &&
            <div className="row">
              <div className="col-4" ><input onChange={(e) => this.props.liftGlobalState({ name: "auditorsPass" }, e.target.value)} className="form-control form-control-sm primary input-compressed" type="password" id="auditors-password" placeholder="Inspecting Officer's Password / OTP" /></div>
              <div className="col-2" ><span onClick={this.handleAuditorsLogin} className="form-toggle-button">Load</span></div>
            </div>
          }

          {formState == 'audit' && auditorsData.length != 0 &&
            <div className="row">
              <div className="col-5" >
                <SelectAudit
                  liftState={this.props.liftState}
                  liftGlobalState={this.props.liftGlobalState}
                  parentState={this.props.parentState}
                />
              </div>

              <div className="col-sm-7">
                <MdErrorOutline
                  id="auditTrailReport"
                  style={{
                    fontSize: "20px",
                    color: "#990000",
                    borderColor: "white",
                  }}
                  className="hand"
                />
                <UncontrolledTooltip style={styles.requiredFields} placement="bottom" target="auditTrailReport">
                  <ShowAuditTrail auditorsData={auditorsData} />
                </UncontrolledTooltip>
              </div>

            </div>
          }

          {identi && <div className="col-12 row">
            <div className="col-6" ></div>
            <div className="col-2" >
              <Badge
                onClick={this.handleApprove}
                style={{ cursor: "pointer", float: 'right' }}
                color="success"
              >
                Approve
              </Badge>
            </div>
            <div className="col-2" >
              <Badge
                onClick={this.handleRevert}
                style={{ cursor: "pointer", float: 'right' }}
                color="warning"
              >
                Revert
              </Badge>
            </div>
            <div className="col-2" >
              <Badge
                onClick={this.handleDelete}
                style={{ cursor: "pointer", float: 'right' }}
                color="primary"
              >
                Delete
              </Badge>
            </div>
          </div>}
        </div>

        {pageType == "history" &&
          formState == "view" &&
          !starting &&
          otherVisiblePages && (
            <div className="col-6 card bg-faded" style={{ padding: 5 }}>
              <span>
                {otherVisiblePages.map((page, index) => (
                  <span key={index}>
                    <Badge
                      color="dark"
                      onClick={() => this.changeOtherPage(page.pageName)}
                      className={`link-button ${otherPage == page.pageName ? "link-button-selected" : ""
                        }`}
                    >
                      {db[page.pageName].label}
                    </Badge>
                    &nbsp;
                  </span>
                ))}
              </span>
            </div>
          )}

        {pageType == "report" && (
          <div className="col-6">
            <div className="row">
              {/* <div className="col-6">By: Amrutraj Gore</div> */}
              <div className="col-4" />
              {/* <div className="col-2"><Badge onClick={this.handleClose} color="danger" >Close</Badge></div> */}
              {/* <div className="col-6">
                On: {moment().format("DD/MM/YYYY, h:mm:ss a")}
              </div> */}
              {/* <div className="col-6">Version: 1</div> */}
              {/* <div className="col-6">ID: {this.props.OriginalData.length>0 ? this.props.OriginalData[0].requestID : ""}</div> */}
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default Header;
